// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3sCkS","actions":"GroupTable_actions__125Iy","deleteModalFooter":"GroupTable_deleteModalFooter__JwUIh"};